//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { SliceNames } from '@redux/SliceNames';
import { createSlice } from '@reduxjs/toolkit';
import { ITwitterPostDetailsModalState } from '@twitter/redux/post-details/modals/twitterPostDetailsModalsModel';

const initialState: ITwitterPostDetailsModalState = {
  isMediaErrorModalOpen: false,
};

const { actions, reducer } = createSlice({
  name: SliceNames.TwitterPostDetailsModals,
  initialState,
  reducers: {
    toggleMediaErrorModal(state) {
      state.isMediaErrorModalOpen = !state.isMediaErrorModalOpen;
    },
  }
});

export const {
  toggleMediaErrorModal
} = actions;

export default reducer;
